export default {
  allowAlignment: true,
  autoCenter: ['initialHeading', 'image', 'button']
};